module.exports = __webpack_public_path__ + "img/lightbulb-exclamation-on.1e8f1ee8.svg";